import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  changeFieldUpdateUser,
  resetPasswordByOld,
  getUserAccountLock,
  userResetPassword,
} from '../actions/Users';
import DropdownSelect from './ProposalGenerator/DropdownSelect';
import UpdateUserForm from './UpdateUserForm';
import Toggle from './Toggle';
import AddSecurityCodeModal from './AddSecurityCodeModal';
import CustomModal from './CustomModal';

import { useUpdateUserModal } from '../hooks';
import ResetPassword from './ResetPassword';
import utils from '../lib/utils';

const adminItems = [
  { label: 'Agent', value: 'agent' },
  { label: 'Admin', value: 'admin' },
  { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  { label: 'User', value: 'user' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'Support Engineer', value: 'supportEngineer' },
  { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

const superAdminItems = [
  { label: 'User', value: 'user' },
  { label: 'Agent', value: 'agent' },
  { label: 'Admin', value: 'admin' },
  { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  { label: 'SuperAdmin', value: 'superAdmin' },
  // { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'Support Engineer', value: 'supportEngineer' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
  { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

const companyGroupAdminItems = [
  { label: 'User', value: 'user' },
  // { label: 'Agent', value: 'agent' },
  { label: 'Admin', value: 'admin' },
  { label: 'Enterprise Admin', value: 'enterpriseAdmin' },
  // { label: 'QuoteToolAdmin', value: 'quoteToolAdmin' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'Support Engineer', value: 'supportEngineer' },
  { label: 'CompanyGroupAdmin', value: 'companyGroupAdmin' },
  { label: 'CompanyGroupManager', value: 'companyGroupManager' },
];

const ALLOWED_ROLES_ACCOUNT_UNLOCK = ['superAdmin', 'companyGroupAdmin'];

const UpdateUserModal = ({
  isOpen,
  onConfirm,
  onCancel,
  users,
  resetPasswordByOld,
  user,
  userRole,
  updateUser,
  changeFieldUpdateUser,
  securityPassed,
  hideSecurityModal,
  getUserAccountLock,
  userResetPassword,
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [role, setRole] = useState(users.updateUser.role);
  const [modalStatus, setModalStatus] = useState(false);
  const [selectRole, setSelectRole] = useState(undefined);
  const [selectionTrigger, setSelectionTrigger] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [readOnlyTriggered, setReadOnlyTriggered] = useState(false);
  const [readOnlyValue, setReadOnlyValue] = useState(users.updateUser.readOnly);
  const [isReleaseNotesAdmin, setIsReleaseNoteAdmin] = useState(
    users.updateUser.isReleaseNotesAdmin,
  );
  const [lockReminder, setLockReminder] = useState(users.updateUser.lockReminder);
  const [isApprover, setIsApprover] = useState(users.updateUser.isAccountApprover);
  const [tempRole, setTempRole] = useState(undefined);
  const [accountLocked, setAccountLocked] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [resetForm, setResetForm] = useState(null);
  const [monitorSecurityModal, setMonitorSecurityModal] = useState(false);
  const [selectedDM, setSelectedDM] = useState(null);
  const [realTimeActivityStatus, setRealTimeActivityStatus] = useState(users?.updateUser?.realTimeActivityEnabled || false);
  const [deleteLock, setDeleteLock] = useState(users?.updateUser?.deleteLock || false);
  const [warehouseQcAccess, setWarehouseQcAccess] = useState(users?.updateUser?.warehouseQcAccess || false);
  const [recAccess, setRecAccess] = useState(users?.updateUser?.warehouseQcRecAccess || false);
  const [eth3Access, setEth3Access] = useState(users?.updateUser?.eth3Access || false);

  const token = localStorage.getItem('jwtToken');

  const myRole = useMemo(() => user.role, [user]);

  const { hasUserPermissionToChange } = useUpdateUserModal();

  const [portAccess, setPortAccess] = useState(users?.updateUser?.portingAccessEnabled);

  const [dataCenterMonitor, setDataCenterMonitor] = useState(
    users?.updateUser?.dataCenterMonitor || false,
  );
  const [deviceMonitor, setDeviceMonitor] = useState(users?.updateUser?.deviceMonitor || false);
  const [numberCarrierChageAccess, setNumberCarrierChageAccess] = useState(
    users?.updateUser?.numberCarrierChageAccess || false,
  );

  const getData = async () => {
    let roleList = [];
    if (userRole === 'superAdmin') {
      roleList = superAdminItems;
    } else if (userRole === 'companyGroupAdmin') {
      roleList = companyGroupAdminItems;
    } else {
      roleList = adminItems;
    }
    const currentRole = roleList.find(el => el.value === updateUser.role) || roleList[0];
    const { isAccountLocked } = await getUserAccountLock(token, users.updateUser._id);
    setSelectRole(currentRole);
    setSelectedValue(currentRole.value);
    setTempRole(selectedValue);
    setAccountLocked(isAccountLocked);
  };

  useEffect(() => {
    setRole(users.updateUser.role);
  }, [users.updateUser.role]);

  useEffect(() => {
    getData().catch(console.error);
  }, []);

  useEffect(() => {
    if (securityPassed) {
      submitResetCall('sudo');
    }
  }, [securityPassed]);

  const submitResetCall = async e => {
    const id = users.updateUser._id;
    hideSecurityModal();
    if (newPassword === repeatNewPassword) {
      await resetPasswordByOld(token, id, oldPassword, newPassword, e === 'sudo');
      setNewPassword('');
      setOldPassword('');
      setRepeatNewPassword('');
    } else {
      setErrorMessage('New password and its confirmation do not match. Please, re-enter!');
    }
  };
  const onSubmit = async e => {
    const { auto, email, password, loginFirst, confirmPassword } = resetForm;
    // console.log('resetForm', resetForm);

    const body = {
      hasGeneratePassword: auto,
      userPassword: password,
      resetUserID: updateUser._id,
      hasSendAdminEmail: email,
      hasResetPasswordOnLogin: loginFirst,
    };

    const reset = await userResetPassword(token, body);
    if (reset.success) {
      setResetModal(false);
      setResetForm(null);
    }
    // console.log('::: resetForm :::', body);
  };
  const currentSelectedRole = role => {
    const roleList =
      userRole === 'superAdmin'
        ? superAdminItems
        : userRole === 'companyGroupAdmin'
          ? companyGroupAdminItems
          : adminItems;
    return roleList.find(el => el.value === role) || roleList[0];
  };

  const changeFieldUpdate = () => {
    const currentRole = currentSelectedRole(!!tempRole ? tempRole : selectedValue);
    setModalStatus(false);
    setSelectionTrigger(true);
    setSelectRole({ ...currentRole });
    setSelectedValue(currentRole.value);
    changeFieldUpdateUser('role', tempRole ? tempRole : selectedValue);
  };

  const onReadOnlyToggleChange = async () => {
    await changeFieldUpdateUser('readOnly', !updateUser.readOnly);
    setReadOnlyValue(
      selectedValue === 'superAdmin' ||
        selectedValue === 'companyGroupAdmin' ||
        selectedValue === 'admin' ||
        selectedValue === 'enterpriseAdmin'
        ? !readOnlyValue
        : false,
    );
  };

  const checkSecurityCode = () => {
    if (readOnlyTriggered) {
      onReadOnlyToggleChange();
    } else {
      changeFieldUpdate();
    }
    setSelectionTrigger('confirm');
    setModalStatus(false);
  };

  const onWrongCode = () => {
    const currentRole = currentSelectedRole(userRole);
    // setSelectRole(currentRole);
    setTempRole(userRole);
    setSelectedValue(currentRole.value);
  };

  const roleSelection = async value => {
    const currentRole = currentSelectedRole(value);
    if (value === 'superAdmin') {
      setModalStatus(true);
    } else {
      changeFieldUpdateUser('role', value);
      setSelectionTrigger('');
    }
    setReadOnlyTriggered(false);
    setSelectRole(currentRole);
    setTempRole(value);
    setSelectedValue(value);

    if (userRole === 'superAdmin' && role === 'superAdmin') {
      const KEY_IN_REDUX_STATE = 'dataCenterMonitor';
      const KEY_IN_REDUX_STATE_DM = 'deviceMonitor';
      setDataCenterMonitor(false);
      setDeviceMonitor(false);
      setNumberCarrierChageAccess(false);
      await changeFieldUpdateUser(KEY_IN_REDUX_STATE, false);
      await changeFieldUpdateUser(KEY_IN_REDUX_STATE_DM, false);
      await changeFieldUpdateUser('numberCarrierChageAccess', false);
    }
  };

  const onUpdateConfirm = async () => {
    await changeFieldUpdateUser('isReleaseNotesAdmin', isReleaseNotesAdmin);
    onConfirm({ accountLocked });
  };
  const onLockReminder = async e => {
    const { currentTarget } = e;
    setLockReminder(!currentTarget.checked);
    await changeFieldUpdateUser('lockReminder', !currentTarget.checked);
  };

  const onApproverPress = async e => {
    setIsApprover(!isApprover);
    await changeFieldUpdateUser('isAccountApprover', !isApprover);
  };

  const portAccessHandleChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'portingAccessEnabled';
    setPortAccess(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !portAccess);
  }, [portAccess]);

  const realTimeActivityChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'realTimeActivityEnabled';
    setRealTimeActivityStatus(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !realTimeActivityStatus);
  }, [realTimeActivityStatus]);
  
  const onDeleteLockChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'deleteLock';
    setDeleteLock(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !deleteLock);
  }, [deleteLock]);

  const onAccountLockedChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'accountLocked';
    setAccountLocked(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !accountLocked);
  }, [accountLocked]);

  const onWarehouseQcChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'warehouseQcAccess';
    setWarehouseQcAccess(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !warehouseQcAccess);
  }, [warehouseQcAccess]);

  const onRecAccessChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'warehouseQcRecAccess';
    setRecAccess(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !recAccess);
  }, [recAccess]);

  const dataCenterMonitorChange = () => {
    setSelectedDM('dataCenterMonitor');
    setMonitorSecurityModal(true);
  };

  const deviceMonitorChange = () => {
    setSelectedDM('deviceMonitor');
    setMonitorSecurityModal(true);
  };
  const onCarrierAcess = () => {
    setSelectedDM('numberCarrierChageAccess');
    setMonitorSecurityModal(true);
  };

  const onEth3AccessChange = useCallback(async () => {
    const KEY_IN_REDUX_STATE = 'eth3Access';
    setEth3Access(prev => !prev);
    await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !eth3Access);
  }, [eth3Access]);

  const onMonitorSecurityConfirm = async () => {
    if (selectedDM === 'dataCenterMonitor') {
      const KEY_IN_REDUX_STATE = 'dataCenterMonitor';
      setDataCenterMonitor(prev => !prev);
      await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !dataCenterMonitor);
    } else if (selectedDM === 'deviceMonitor') {
      const KEY_IN_REDUX_STATE = 'deviceMonitor';
      setDeviceMonitor(prev => !prev);
      await changeFieldUpdateUser(KEY_IN_REDUX_STATE, !deviceMonitor);
    } else if (selectedDM === "numberCarrierChageAccess") {
      setNumberCarrierChageAccess(prev => !prev);
      await changeFieldUpdateUser("numberCarrierChageAccess", !numberCarrierChageAccess);
    }
    setMonitorSecurityModal(false);
  };

  const isUserAllowedToUnlockAccount = () => {
    return ALLOWED_ROLES_ACCOUNT_UNLOCK.includes(userRole);
  };

  const onResetPassword = async () => {
    setResetModal(true);
  };

  const formValues = values => {
    setResetForm(values);
  };

  const hiddenCarrier = () => {
    if (
      (userRole === 'superAdmin' || userRole === 'companyGroupAdmin') &&
      (role === 'superAdmin' || role === 'companyGroupAdmin')
    ) {
      return false;
    }
    return true;
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Update User</ModalHeader>
      <ModalBody>
        <UpdateUserForm role={role} permission={hasUserPermissionToChange} />
        <Container>
          {(role === 'superAdmin' || role === 'companyGroupAdmin') &&
          (myRole === 'admin' ||
            myRole === 'companyGroupManager' ||
            myRole === 'enterpriseAdmin') ? null : (
            <>
              <Form id="updatePassUser">
                <FormGroup>
                  <Button
                    disabled={role === 'superAdmin' && myRole === 'companyGroupAdmin'}
                    onClick={onResetPassword}
                    color="primary"
                  >
                    Reset Password
                  </Button>
                </FormGroup>
              </Form>
              {/* <Button color="primary" type="submit" form="updatePassUser">
              Update Password
            </Button>
            </Collapse> */}
              <Row>
                {userRole === 'superAdmin' ||
                (userRole === 'companyGroupAdmin' && role !== 'superAdmin') ? (
                  <Col sm={12} md={6}>
                    <FormGroup row>
                      <Label sm={4}>Role:</Label>
                      <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
                        {selectRole && (
                          <DropdownSelect
                            options={
                              userRole === 'superAdmin'
                                ? superAdminItems
                                : userRole === 'companyGroupAdmin'
                                ? companyGroupAdminItems
                                : adminItems
                            }
                            type="user"
                            selectionTrigger={selectionTrigger}
                            trgiggerText={'superAdmin'}
                            selectedOption={selectRole}
                            onSelect={({ value }) => roleSelection(value)}
                          />
                        )}
                      </Col>
                    </FormGroup>
                  </Col>
                ) : null}
                <Col sm={6} md={2}>
                  <FormGroup row>
                    <Label for="enabled" sm={4}>
                      Status:
                    </Label>
                    <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={updateUser.enabled}
                        onToggle={value => changeFieldUpdateUser('enabled', !value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                {(selectedValue === 'superAdmin' ||
                  selectedValue === 'companyGroupAdmin' ||
                  selectedValue === 'admin' ||
                  selectedValue === 'enterpriseAdmin') && (
                  <Col
                    sm={6}
                    md={3}
                    hidden={
                      (role !== 'superAdmin' && role !== 'companyGroupAdmin' && role !== 'admin') ||
                      updateUser._id === user._id
                    }
                  >
                    <FormGroup row>
                      <Label for="enabled" sm={12}>
                        Read-only:
                      </Label>
                      <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                        <Toggle
                          value={readOnlyValue}
                          onToggle={() => {
                            setModalStatus(true);
                            setReadOnlyTriggered(true);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={6} sm={6} hidden={role !== 'superAdmin'}>
                  <FormGroup row>
                    <Label for="enabled" sm={12}>
                      Release Notes Admin:
                    </Label>
                    <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={isReleaseNotesAdmin}
                        onToggle={value => {
                          setIsReleaseNoteAdmin(!isReleaseNotesAdmin);
                        }}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
          {console.log('userRole :::', userRole, 'role ::::', users.updateUser)}
          {userRole === 'superAdmin' && role === 'companyGroupAdmin' && (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input type="checkbox" checked={isApprover} onChange={onApproverPress} />
                User Account Approver
              </Label>
            </FormGroup>
          )}
          <FormGroup style={{ marginLeft: '20px' }}>
            <Label check>
              <Input type="checkbox" checked={!lockReminder} onChange={onLockReminder} />
              Ignore device lock message
            </Label>
          </FormGroup>
          {isUserAllowedToUnlockAccount() && (
              <FormGroup style={{ marginLeft: '20px' }}>
                <Label check>
                  <Input type="checkbox" checked={accountLocked} onChange={onAccountLockedChange} />
                  Account Locked
                </Label>
              </FormGroup>
          )}
          {!hiddenCarrier() ? (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input
                  disabled={userRole !== 'superAdmin'}
                  type="checkbox"
                  checked={portAccess}
                  onChange={portAccessHandleChange}
                />
                Carrier Hub: Porting Access
              </Label>
            </FormGroup>
          ) : null}

          {!hiddenCarrier() ? (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input
                  // disabled={userRole !== 'superAdmin'}
                  type="checkbox"
                  checked={realTimeActivityStatus}
                  onChange={realTimeActivityChange}
                />
                PCAP Access
              </Label>
            </FormGroup>
          ) : null}

          {userRole === 'superAdmin' && role === 'superAdmin' && (
            <>
              <Label className="font-weight-bold" for="enabled" sm={12}>
                Access Control:
              </Label>
              <FormGroup style={{ marginLeft: '20px' }}>
                <Label check>
                  <Input
                    disabled={userRole !== 'superAdmin'}
                    type="checkbox"
                    checked={dataCenterMonitor}
                    onChange={dataCenterMonitorChange}
                  />
                  Data Center Monitor
                </Label>
              </FormGroup>
              {/* <FormGroup style={{ marginLeft: '20px' }}>
                <Label check>
                  <Input
                    disabled={userRole !== 'superAdmin'}
                    type="checkbox"
                    checked={deviceMonitor}
                    onChange={deviceMonitorChange}
                  />
                  Device Monitor
                </Label>
              </FormGroup> */}
              <FormGroup style={{ marginLeft: '20px' }}>
                <Label check>
                  <Input
                    disabled={userRole !== 'superAdmin'}
                    type="checkbox"
                    checked={numberCarrierChageAccess}
                    onChange={onCarrierAcess}
                  />
                  Carrier Access
                </Label>
              </FormGroup>
            </>
          )}
          {userRole === 'superAdmin' && (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input type="checkbox" checked={deleteLock} onChange={onDeleteLockChange} />
                System Service Account
              </Label>
            </FormGroup>
          )}
          
          {isUserAllowedToUnlockAccount() && (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input type="checkbox" checked={warehouseQcAccess} onChange={onWarehouseQcChange} />
                Warehouse QC Wizard
              </Label>
            </FormGroup>
          )}
          
          {isUserAllowedToUnlockAccount() && (
            <Row>
              <Col md={1} sm={1} ></Col>
              <FormGroup style={{ marginLeft: '20px' }}>
                <Label check>
                  <Input type="checkbox" checked={recAccess} onChange={onRecAccessChange} disabled={!warehouseQcAccess} />
                  Allow REC Access
                </Label>
              </FormGroup>
            </Row>
          )}
          
          {isUserAllowedToUnlockAccount() && (
            <FormGroup style={{ marginLeft: '20px' }}>
              <Label check>
                <Input type="checkbox" checked={eth3Access} onChange={onEth3AccessChange} />
                Eth0/3 Access management
              </Label>
            </FormGroup>
          )}

        </Container>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>{' '}
        <Button color="primary" onClick={onUpdateConfirm}>
          Update User
        </Button>
      </ModalFooter>
      <AddSecurityCodeModal
        isOpen={modalStatus}
        onCancel={() => {
          setSelectionTrigger('cancel');
          setModalStatus(!modalStatus);
          onWrongCode();
        }}
        onConfirm={checkSecurityCode}
        onWrongCode={onWrongCode}
        superCode
        featureName="superCode"
      />
      <CustomModal
        isOpen={resetModal}
        onCancel={() => setResetModal(false)}
        header="Reset Password"
        onConfirm={onSubmit}
        confirmDisabled={
          !resetForm?.auto &&
          (!utils.validatePassword(resetForm?.password, updateUser.email) ||
            resetForm?.password !== resetForm?.confirmPassword)
        }
      >
        <ResetPassword formValues={formValues} />
      </CustomModal>
      <AddSecurityCodeModal
        isOpen={monitorSecurityModal}
        onCancel={() => {
          setMonitorSecurityModal(false);
          setSelectedDM(null);
        }}
        onConfirm={onMonitorSecurityConfirm}
        monitorCode
        featureName="monitorCode"
      />
    </Modal>
  );
};

const mapStateToProps = state => ({
  users: state.UIState.users,
  user: state.AppState.user,
  userRole: state.AppState.user.role,
  updateUser: state.UIState.users.updateUser,
  securityCode: state.UIState.users.addedUser.security,
});

const mapDispatchToProps = dispatch => ({
  resetPasswordByOld: (token, id, oldPass, newPass, godMode) =>
    dispatch(resetPasswordByOld(token, id, oldPass, newPass, godMode)),
  changeFieldUpdateUser: (name, value) => dispatch(changeFieldUpdateUser(name, value)),
  getUserAccountLock: (token, userID) => dispatch(getUserAccountLock(token, userID)),
  userResetPassword: (token, body) => dispatch(userResetPassword(token, body)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserModal);
